import { useQuery } from '@tanstack/react-query'
import { Clock } from 'lucide-react'
import { schedulerHealth } from '@/api/settings'
import { useAuth } from '@/hooks/useAuth'

/**
 * Admins only: the scheduler heartbeat (written every minute by cron → schedule:run) is older
 * than the server's stale limit (10 min), so nightly backups, reminders and SLA scans have stopped.
 */
export function SchedulerHealthBanner() {
  const { user, hasRole } = useAuth()
  const admin = !!user && hasRole(['HR_ADMIN'])
  const q = useQuery({
    queryKey: ['system', 'scheduler-health'],
    queryFn: schedulerHealth,
    enabled: admin,
    staleTime: 5 * 60_000,
    refetchInterval: 5 * 60_000,
    retry: false,
    meta: { inlineError: true },
  })
  const h = q.data
  if (!admin || !h?.stale) return null
  const mins = h.age_seconds != null ? Math.round(h.age_seconds / 60) : null
  return (
    <div role="alert" data-testid="scheduler-health-banner" className="flex items-start gap-2 border-b border-warning/30 bg-warning-subtle px-4 py-2 text-sm text-warning-content print:hidden">
      <Clock className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span>
        <span className="font-semibold">Scheduled jobs are not running.</span>{' '}
        {mins == null ? 'The scheduler has never reported in' : `The scheduler last reported ${mins} minute${mins === 1 ? '' : 's'} ago`},
        so nightly backups and reminders are paused. Ask whoever maintains the server to check the cron job (php artisan schedule:run every minute).
      </span>
    </div>
  )
}
